import { Controller } from "@hotwired/stimulus"

// TEMP — Labor Day Sale (Sept 2026). Click-to-copy for the coupon chip in
// shared/_sale_top.html.erb. Safe to delete with that partial.
export default class extends Controller {
  static targets = ["label"]
  static values = { code: String, copiedText: { type: String, default: "Copied ✓" } }

  async copy(event) {
    event.preventDefault()
    if (!navigator.clipboard) return

    try {
      await navigator.clipboard.writeText(this.codeValue)
    } catch {
      return
    }

    if (!this.originalHtml) this.originalHtml = this.labelTarget.innerHTML
    this.labelTarget.textContent = this.copiedTextValue
    this.element.classList.add("is-copied")

    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.reset(), 1600)
  }

  reset() {
    if (this.originalHtml) this.labelTarget.innerHTML = this.originalHtml
    this.element.classList.remove("is-copied")
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
